import { Component, Injector, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { TimesheetUtilityService } from '@app/main/time-sheet-new/services/timesheet-utility.service';
import { MonitoringService } from '@app/shared/common/telemetry-implementation/MonitoringService ';
import { AppRoutes } from '@app/shared/routes/app-routes';
import * as _ from 'lodash';
import { DateTime } from 'luxon';
import { AppComponentBase } from '../../../../../shared/common/app-component-base';
import { ActivityServiceProxy, AllDashboardServiceProxy, GetApplicationsDto } from '../../../../../shared/service-proxies/service-proxies';
@Component({
    standalone: false,
    selector: 'app-dashboard-unproductiveapps',
    templateUrl: './dashboard-unproductiveapps.component.html',
    styleUrls: ['./dashboard-unproductiveapps.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardUnproductiveappsComponent extends AppComponentBase implements OnInit, OnDestroy {
    UnProductiveAppsDetails: GetApplicationsDto[];
    isUnProductiveLoaded = false;
    isEmpty = true;
    istrueValue: boolean;
    showUnproductive: any;
    dateTime = new Date();
    constructor(private _monitorService: MonitoringService, private _AllDashboardServiceProxy: AllDashboardServiceProxy, private _activitesServiceProxy: ActivityServiceProxy, public _tus: TimesheetUtilityService, private router: Router, injector: Injector) { super(injector); }
    ngOnInit(): void {
        this.getAllUnProductiveApps();
    }
    getAllUnProductiveApps() {
        let date = new Date();
        this._monitorService.logEvent("getAllUnProductiveApps", { "getAllUnProductiveApps": "getAllUnProductiveApps: " + this.dateTime });
        this.istrueValue = this.isGranted('Pages.ShowManager.Dashboard');
        this._AllDashboardServiceProxy.getUserWiseUnProductiveApplication('', [], [], [], this.istrueValue, undefined, false, date.getTimezoneOffset()).subscribe(result => {
            this.UnProductiveAppsDetails = [];
            result = _.orderBy(result, ['applicationSpendTime'], ['desc']);
            result.forEach(x => {
                if (x.applicationSpendTime) {
                    this.isEmpty = false;
                    this.UnProductiveAppsDetails.push(x);
                }
            });
            this.isUnProductiveLoaded = true;
            this.markForCheck();
        });
    }
    viewall() {
        this.router.navigate([AppRoutes.activitiesTimeAndAttendance]);
    }
    ngOnDestroy() {
        if (this.showUnproductive) {
            clearInterval(this.showUnproductive);
        }
    }
    ShowDetails = false;
    LoadingStarted = false;
    HistoryForApp = "";
    HistoryDetails = [];
    userId = abp.session.userId;
    tenantId = abp.session.tenantId;
    GetData(appName: string) {
        this._monitorService.logTrace("UI-GetData", { "getData ": "stagetActiveWindowsHistoryForApprt: " + this + this.dateTime });
        this.HistoryForApp = appName;
        this.ShowDetails = false;
        document.getElementsByClassName('popTemplateClass')[0].className += ' display-none';
        this.LoadingStarted = true;
        this._activitesServiceProxy.getActiveWindowsHistoryForApp(appName, DateTime.fromJSDate(this.setZeroTimeForLocalDate(new Date())), this.userId, this.tenantId).subscribe(res => {
            this.HistoryDetails = res;
            this.LoadingStarted = false;
            this.HistoryForApp = "";
            if (this.HistoryDetails.length > 0) {
                this.ShowDetails = true;
                let element = document.getElementsByClassName('popTemplateClass');
                for (let i = 0; i < element.length; i++) {
                    element[i].className = element[i].className.replace(/\bdisplay-none\b/, "");
                }
            }
            else {
                this.ShowDetails = false;
                document.getElementsByClassName('popTemplateClass')[0].className += ' display-none';
            }
            this.markForCheck();
        });
    }
    setZeroTimeForLocalDate(date: Date): Date {
        date.setHours(0, 0, 0, 0);
        return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
    }
    removeData() {
        this.HistoryForApp = "";
        this.LoadingStarted = false;
        this.ShowDetails = false;
        this.HistoryDetails = [];
    }
}
